import VueI18n, { TranslateResult, createI18n, useI18n } from 'vue-i18n';
import ja from './locales/ja.json';
import en from './locales/en.json';
import jaToKey from './langToKeys/ja.json';
import enToKey from './langToKeys/en.json';
/* vue 2.x
import Vue from 'vue'
// Vue.use(VueI18n)
const i18nModule = new VueI18n({
    locale: 'ja',
    fallbackLocale: 'en',
    messages: {
        'ja': ja,
        'en': en
    },
    silentTranslationWarn: true
})
*/

const i18nModule = createI18n({
  locale: 'ja',
  fallbackLocale: 'en',
  messages: {
    ja: ja,
    en: en,
  },
  silentTranslationWarn: true,
});
const i18nToKeyDictionary = {
  ja: jaToKey,
  en: enToKey,
};

const i18n = i18nModule.global;

export { i18n, i18nModule, i18nToKeyDictionary, TranslateResult };
